import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend';
import translationEN from './locales/en/en.json'
import translationVI from './locales/vi/vi.json'
import axios from "axios";
import { STORAGE_KEY } from './utils/constant';

const resources = {
    en: { translation: translationEN },
    vi: { translation: translationVI }
};

i18next.use(HttpApi).use(initReactI18next).init({
    lng: localStorage.getItem(STORAGE_KEY.LANGUAGE) ? localStorage.getItem(STORAGE_KEY.LANGUAGE) : 'vi',
    debug: true,
    resources
})

// i18next.use(HttpApi)
//     .use(initReactI18next)
//     .init({
//         fallbackLng: localStorage.getItem(STORAGE_KEY.LANGUAGE) ? localStorage.getItem(STORAGE_KEY.LANGUAGE) : 'vi',
//         backend: {
//             // Path to your API endpoint
//             // {{lng}} and {{ns}} are dynamic placeholders for language and namespace
//             loadPath: `http://45.119.84.202:8081/locales/${localStorage.getItem(STORAGE_KEY.LANGUAGE) || 'vi'}/${localStorage.getItem(STORAGE_KEY.BUSINESS_TYPE) || 'default'}.json`,
//             // request: async (options, url, payload, callback) => {
//             //     try {
//             //         const response = await axios.get(`http://45.119.84.202:8081/${localStorage.getItem(STORAGE_KEY.BUSINESS_TYPE) || 'default'}.json`, { crossDomain: true });
//             //         debugger
//             //         const data = await response.data.json();
//             //         // callback(error, result)
//             //         callback(null, {
//             //             status: 200,
//             //             data: data
//             //         });
//             //     } catch (err) {
//             //         callback(err, null);
//             //     }
//             // },
//             // crossDomain: false,
//             // overrideMimeType: false,
//         },
//         // Other options
//         // interpolation: {
//         //     escapeValue: false,
//         // }
